import { styled } from '@goodfynd/react-web.theme';

export const StyledContainer = styled('div', {
  padding: 24,
});
